import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, XCircle } from "lucide-react";
import client from "@/lib/api";
import { useCart } from "@/context/CartContext";
import OrderSuccess from "@/components/OrderSuccess";

export default function PaymentResult({ cancelled = false }) {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const { clear } = useCart();
  const [status, setStatus] = useState("polling");
  const [order, setOrder] = useState(null);
  const tries = useRef(0);

  useEffect(() => {
    if (cancelled) return;
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }
    let stop = false;
    const poll = async () => {
      if (stop) return;
      tries.current += 1;
      try {
        const { data } = await client.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          clear();
          setOrder({ ...data.order, payStatus: "paid" });
          setStatus("paid");
          return;
        }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("failed"); return; }
      } catch {
        setStatus("error"); return;
      }
      if (tries.current >= 12) { setStatus("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { stop = true; };
  }, [cancelled]);

  if (cancelled) {
    return (
      <div dir="rtl" className="text-center pt-20 px-8">
        <XCircle size={48} className="mx-auto mb-4" style={{ color: "var(--k-ruby)" }} />
        <h2 className="font-head text-[18px] font-bold mb-1.5">تم إلغاء الدفع</h2>
        <p className="text-[13px] mb-6" style={{ color: "var(--k-ink-soft)" }}>لم يكتمل الدفع. يمكنك المحاولة مرة أخرى من السلة.</p>
        <button onClick={() => nav("/cart")} className="k-tap px-6 py-3 rounded-2xl text-white font-bold text-[13.5px]" style={{ background: "var(--k-ink)" }}>العودة للسلة</button>
      </div>
    );
  }

  if (status === "paid" && order) return <OrderSuccess order={order} />;

  if (["error", "failed", "timeout"].includes(status)) {
    return (
      <div dir="rtl" className="text-center pt-20 px-8">
        <XCircle size={48} className="mx-auto mb-4" style={{ color: "var(--k-ruby)" }} />
        <h2 className="font-head text-[18px] font-bold mb-1.5">تعذّر تأكيد الدفع</h2>
        <p className="text-[13px] mb-6" style={{ color: "var(--k-ink-soft)" }}>إذا تم خصم المبلغ فسيؤكَّد طلبك تلقائيًا. راجع "طلباتي" لاحقًا.</p>
        <button onClick={() => nav("/")} className="k-tap px-6 py-3 rounded-2xl text-white font-bold text-[13.5px]" style={{ background: "var(--k-ink)" }}>الرئيسية</button>
      </div>
    );
  }

  return (
    <div dir="rtl" className="text-center pt-24 px-8">
      <Loader2 size={40} className="mx-auto mb-4 animate-spin" style={{ color: "var(--k-gold)" }} />
      <p className="text-[14px] font-semibold">جارٍ تأكيد الدفع…</p>
      <p className="text-[12px] mt-1" style={{ color: "var(--k-ink-soft)" }}>لا تغلق هذه الصفحة</p>
    </div>
  );
}
